import { insertIntoArray } from '../utils';
import {
  buildAdditionalContactCard,
  type ContactCardOverrides,
} from './additionalContactCard';

export const homeWarrantyContactCard = buildAdditionalContactCard({
  contactType: 'homeWarranty',
  contactLabel: 'Home Warranty',
  overrides: {
    displayFields: (defaultFields) => [
      {
        name: 'contacts.homeWarranty.x.confirmationNumber',
        type: 'default',
      },
      ...defaultFields,
    ],
    layout: (defaultLayout) =>
      insertIntoArray(defaultLayout, 1, [
        {
          name: 'contacts.homeWarranty.x.confirmationNumber',
          size: 100,
        },
      ]),
    fields: {
      role: {
        label: 'Role',
        placeholderText: 'Representative, Assistant, etc',
      },
      confirmationNumber: {
        name: 'contacts.homeWarranty.x.confirmationNumber',
        entity: 'contacts',
        entityType: 'homeWarranty',
        type: 'text',
        label: 'Confirmation Number',
        placeholderText: '',
      },
    },
  } satisfies ContactCardOverrides,
});
